// extracted by mini-css-extract-plugin
export default {"content":"information_content__vEv9N","form":"information_form__YUDyU"};